const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
    <path
      d="M2.5 7L5.5 10L11.5 4"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export const FormCheckbox = ({
  checked = false,
  onChange,
  label = "",
  disabled = false,
  error = "",
  className = "",
  id,
}) => {
  const toggleCheckbox = () => {
    if (disabled) return;
    onChange?.(!checked);
  };

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <button
        id={id}
        type="button"
        role="checkbox"
        aria-checked={checked}
        disabled={disabled}
        onClick={toggleCheckbox}
        className={`group flex items-start gap-2.5 text-left custom-transition outline-none ${
          disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
        }`}
      >
        <span
          className={`flex size-5 shrink-0 items-center justify-center rounded-[4px] custom-transition duration-200 group-focus-visible:ring-2 group-focus-visible:ring-[#4ab933]/40 ${
            checked
              ? "bg-[#4ab933] text-white"
              : error
              ? "border border-red-500 bg-background-surface"
              : "border border-divider bg-background-surface group-hover:border-text-secondary"
          }`}
        >
          {checked && <CheckIcon />}
        </span>

        {label && (
          <span className="text-sm font-medium leading-[20px] text-text-secondary custom-transition group-hover:text-text-primary">
            {label}
          </span>
        )}
      </button>

      {error && <p className="text-xs text-red-500 pl-7">{error}</p>}
    </div>
  );
};

export default FormCheckbox;
